import React, { useCallback } from 'react';
import Section from '../v2/Section/Section';
import { Stack } from '../v2/Stack/Stack';
import Icon from '../v2/Icon/Icon';
import Spacer from '../v2/Spacer/Spacer';
import Typography from '../v2/Typography/Typography';
import List from '../v2/List/List';
import Button from 'components/v2/Button/Button';
import { Quota } from '../../modules/users/types';
import { useModal } from '../v2/Modal/useModal';
import { useTranslation } from 'utils/translation';

type Props = {
  quota: Quota;
  onClose?(): void;
};

const AccountLimitReached = ({ quota, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Section>
      <Stack direction="column" align="center">
        <Icon name="fa-light fa-triangle-exclamation fa-3x" color="warning" />
        <Spacer size={2} />
        <Typography variant="h2">{t('account_limit_reached.title')}</Typography>
        <Spacer size={2} />
        <Typography align="center">
          {t('account_limit_reached.info')}
          <br />
          {t('account_limit_reached.upgrade')}
        </Typography>
      </Stack>
      <Spacer size={2} />
      <Stack align="center" direction="column">
        <Spacer size={3} />
        <Button
          onClick={() => {
            window.open('https://www.quodoc.com/meer/prijzen');
            onClose?.();
          }}
          startIcon={<Icon name="fa-regular fa-bolt" />}
        >
          {t('account_limit_reached.action')}
        </Button>
      </Stack>
    </Section>
  );
};

export const useAccountLimitReachedModal = () => {
  const modal = useModal();

  return useCallback(
    ({ quota }: Pick<Props, 'quota'>) => {
      modal.open(
        ({ close }) => <AccountLimitReached quota={quota} onClose={close} />,
        { size: 'tiny' },
      );
    },
    [modal.open],
  );
};

export default AccountLimitReached;
